<template>
  <div class="emap-flow-modal-addAssignee">
    <van-popup v-model="visible" position="bottom" get-container="body" :style="{ width: '100%'}">
      <atom-select
        v-model="form.taskId"
        label="节点"
        type="picker"
        :options="nodeList"
        label-key="nodeName"
        value-key="taskId"
        :disabled="nodeList.length == 1"
        @confirm="nodeChange"
      ></atom-select>
      <div class="emap-flow-assignee">
        <label class="emap-flow-assignee-label">处理人</label>
        <div class="emap-flow-assignee-content" @click="showEmapFlowPick">
          <van-tag plain v-for="item in defaultAssigneesObj" :key="item.userId" class="emap-flow-tag">{{item.userName}}</van-tag>
          <van-tag plain type="primary" v-for="item in assigneesObj" :key="item.userId" class="emap-flow-tag">{{item.userName}}</van-tag>
        </div>
      </div>
      <div class="emap-flow-assignee" v-if="hasMultiInstance">
        <label class="emap-flow-assignee-label">用户组</label>
        <div class="emap-flow-assignee-content" @click="showGroupPick">
          <van-tag plain v-for="item in defaultInstAssigneesObj" :key="item.userId" class="emap-flow-tag">{{ item.userName }}</van-tag>
          <van-tag plain type="primary" v-for="item in instAssigneesObj" :key="item.userId" class="emap-flow-tag">{{ item.userName }}</van-tag>
        </div>
        <van-popup v-model="groupPopup" position="bottom" get-container="body" :style="{ width: '100%'}">
          <div class="van-hairline--top-bottom van-picker__toolbar">
            <button type="button" class="van-picker__cancel" @click="groupPopup = false">取消</button>
            <button type="button" class="van-picker__confirm" @click="onGroupConfirm">确认</button>
          </div>
          <van-checkbox-group v-model="form.instAssignees" class="checkbox-group-container">
            <van-cell-group>
              <van-cell
                v-for="(item, index) in groups"
                clickable
                :key="index"
                @click="toggle(index)">
                <van-checkbox
                  :name="item.userId"
                  ref="groups"
                  shape="square"
                  style="min-height:24px">
                  {{item.userName}}
                </van-checkbox>
              </van-cell>
            </van-cell-group>
          </van-checkbox-group>
        </van-popup>
      </div>
      <van-row>
        <van-col span="12">
          <van-button block square @click="visible = false">取消</van-button>
        </van-col>
        <van-col span="12">
          <van-button type="info" block square @click="onConfirm">确认</van-button>
        </van-col>
      </van-row>
    </van-popup>
    <emap-flow-pick-m 
      v-model="customPick" 
      multiple 
      :options="form.defaultAssignees.concat(form.assignees)" 
      :keyname="assigneesName" 
      :disabledoptions="form.defaultAssignees"
      @on-confirm="onCustomConfirm">
    </emap-flow-pick-m>
  </div>
</template>
<script>
import { AtomSelect } from "../atomic"
import EmapFlowPickM from '../emap-flow-pick-m.vue'
import { getAddOrDelAssignee, queryMultiInstanceGroups } from '@/api/toolbar'

export default {
  name: "change-assignee",
  components: {
    AtomSelect, EmapFlowPickM
  },
  data() {
    return {
      visible: false,
      hasMultiInstance: false,
      nodeList: [],
      groups: [],
      form: {
        taskId: '',
        defaultAssignees: [],
        assignees: [],
        defaultInstAssignees: [],
        instAssignees: []
      },
      assigneesName: '',
      defaultAssigneesObj: [],
      assigneesObj: [],
      defaultInstAssigneesObj: [],
      instAssigneesObj: [],
      customPick: false,
      groupPopup: false
    }
  },
  props: {
    value: Boolean,
    taskid: String,
    defkey: String
  },
  watch: {
    value(val) {
      this.visible = val
      if(val) this.initAddAssignee()
    },
    visible(val) {
      if(!val) this.$emit('input', false)
    }
  },
  methods: {
    initAddAssignee() {
      this.clearVariables()
      getAddOrDelAssignee({
        "taskId": this.taskid, 
        "defKey": this.defkey
      }).then(data => {
        if(data && data.items){
          this.nodeList = data.items
          if(this.nodeList.length === 1) {
            this.form.taskId = this.nodeList[0].taskId
            this.form.defaultAssignees = this.nodeList[0].assignees
            this.defaultAssigneesObj = this.nodeList[0].assigneesObj
            this.assigneesName = this.nodeList[0].assigneesObj.map(obj => {
              return obj.userName
            }).join(',')

            let keys = Object.keys(this.nodeList[0])
            if(keys.includes("candidateGroups")) {
              this.hasMultiInstance = true
              this.form.defaultInstAssignees = this.nodeList[0]["candidateGroups"].map(group => "group(" + group + ")")
              this.defaultInstAssigneesObj = this.nodeList[0]["candidateGroupsObj"].map(group => {
                group.userId = "group(" + group.groupId + ")"
                group.userName = group.groupName
                return group
              })
            }
          }
        }
      })
    },
    clearVariables() {
      this.hasMultiInstance = false
      this.nodeList = []
      this.form = {
        taskId: '',
        defaultAssignees: [],
        assignees: [],
        defaultInstAssignees: [],
        instAssignees: []
      }
      this.defaultAssigneesObj = []
      this.assigneesObj = []
      this.defaultInstAssigneesObj = []
      this.instAssigneesObj = []
      this.groups = []
      this.assigneesName = ""
    },
    nodeChange(item) {
      this.hasMultiInstance = false
      this.form.assignees = []
      this.assigneesObj = []
      this.assigneesName = ""
      this.form.defaultAssignees = item.assignees
      this.defaultAssigneesObj = item.assigneesObj
      this.assigneesName = item.assigneesObj.map(obj => obj.userName).join(',')
      let keys = Object.keys(item)
      if(keys.includes("candidateGroups")) {
        this.hasMultiInstance = true
        this.form.defaultInstAssignees = item["candidateGroups"].map(group => "group(" + group + ")")
        this.defaultInstAssigneesObj = item.candidateGroupsObj.map(group => {
          group.userId = "group(" + group.groupId + ")"
          group.userName = group.groupName
          return group
        })
      }
    },
    showEmapFlowPick() {
      if(!this.form.taskId) {
        this.$toast('请选择节点');
        return
      }
      this.customPick = true;
    },
    showGroupPick() {
      if(!this.form.taskId) {
        this.$toast('请选择节点');
        return
      }
      this.groupPopup = true
      if(!this.groups.length) {
        queryMultiInstanceGroups({ defKey: this.defkey }).then(res => {
          if(res) {
            this.groups = res.filter(opt => {
              opt.userId = "group(" + opt.id + ")"
              opt.userName = opt.name
              return !this.form.defaultInstAssignees.includes(opt.userId)
            })
          } else {
            this.$toast("获取用户组失败")
          }
        })
      }
    },
    toggle(index) {
      this.$refs.groups[index].toggle()
    },
    onCustomConfirm(ids, names, options) {
      this.form.assignees = ids.filter(id => this.form.defaultAssignees.indexOf(id) === -1)
      this.assigneesName = names
      this.assigneesObj = options.filter(item => {
        item.userId = item.id
        item.userName = item.name
        return this.form.defaultAssignees.indexOf(item.userId) === -1
      })
    },
    onGroupConfirm() {
      this.groupPopup = false;
      this.instAssigneesObj = this.groups.filter(item => this.form.instAssignees.includes(item.userId))
    },
    onConfirm() {
      if(!this.form.taskId) {
        this.$toast("请选择节点");
        return
      }
      if(!this.form.assignees.length && !this.form.instAssignees.length){
        this.$toast("节点下处理人/组无变更");
        return
      }

      let tempArr = [...this.form.assignees, ...this.form.instAssignees]
      this.$emit('on-confirm', this.form.taskId, tempArr.join(','))
      this.visible = false
    }
  }
};
</script>
<style scoped>
  .emap-flow-assignee {
    padding: 0 17px;
  }
  .emap-flow-assignee-label {
    float: left;
    width: 84px;
    padding: 8px 0;
  }
  .emap-flow-assignee-content {
    margin-left: 84px;
    height: 160px;
    overflow-y: auto;
    padding: 4px 0 10px;
  }
  .emap-flow-tag {
    margin: 2px 4px 2px 0;
  }
  .emap-flow-pick-m>>>.tree-mask {
    z-index: 9999;
  }
</style>